import type { HTMLAttributes } from 'react';

type Color = 'primary' | 'secondary' | 'ai' | 'success' | 'warning' | 'danger' | 'info' | 'neutral';
type Size = 'sm' | 'md' | 'lg';

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  color?: Color;
  size?: Size;
  outline?: boolean;
}

export function Badge({
  color = 'neutral',
  size = 'md',
  outline = false,
  className,
  children,
  ...rest
}: BadgeProps) {
  const variant = outline ? `badge-outline-${color}` : `badge-${color}`;
  return (
    <span className={`badge badge-${size} ${variant} ${className ?? ''}`.trim()} {...rest}>
      {children}
    </span>
  );
}
